import {
  AttributesDTO,
  ExperimentAttributesDTO,
  ExperimentTypeDTO,
} from '@neptune/shared/core-apis-leaderboard-domain';
import { makeEntityIdentifier } from '@neptune/shared/entity-util';

import { AttributeModelConverter } from 'domain/experiment/attribute';

import { Entity, EntityType, HolderType } from './entity-model';

const entityTypeHolderMap: Record<EntityType, HolderType> = {
  run: 'experiment',
  project: 'project',
};

export class EntityModelConverter {
  static entityFromApiToDomain(entity: AttributesDTO): Entity {
    const domainAttributes = entity.attributes.map(
      AttributeModelConverter.attributeFromApiToDomain,
    );

    return {
      ...entity,
      attributes: domainAttributes,
      id: entity.experimentId,
      type: EntityModelConverter.entityTypeFromApiToDomain(entity.type),
      projectIdentifier: makeEntityIdentifier(entity.organizationName, entity.projectName),
    };
  }

  static entityFromApiExperimentToDomain(experiment: ExperimentAttributesDTO): Entity {
    const attributes = experiment.attributes.map(AttributeModelConverter.attributeFromApiToDomain);

    return {
      id: experiment.id,
      type: 'run',
      attributes,
      organizationId: experiment.organizationId,
      organizationName: experiment.organizationName,
      projectId: experiment.projectId,
      projectName: experiment.projectName,
      projectIdentifier: makeEntityIdentifier(experiment.organizationName, experiment.projectName),
    };
  }

  static entityTypeToHolderType(type: EntityType): HolderType {
    return entityTypeHolderMap[type];
  }

  public static entityTypeFromApiToDomain(type: ExperimentTypeDTO): EntityType {
    switch (type) {
      case ExperimentTypeDTO.Project:
        return 'project';
      case ExperimentTypeDTO.Run:
        return 'run';
    }
  }
}
